export default "__VITE_PUBLIC_ASSET__1becf409__"